import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5336285a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "ガウス整数計算機", -1))
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "math" }
const _hoisted_4 = {
  key: 0,
  class: "blank selected"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "blank selected"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = { class: "panel" }

import { ref, onMounted } from 'vue';
import { Gauss, QGauss } from '@/composable/lib.ts';

interface AtomI{
  num: number;
  error: boolean;
  typ: 'r' | 'i' | '+' | '-' | '*' | '/' | '^' | '(' | ')'
}

export default /*#__PURE__*/_defineComponent({
  __name: 'GaussCalc',
  setup(__props) {

onMounted( () => {
  window.addEventListener('keydown', event => {
    keyDown(event.key);
  });
});

const allChars = ['0','1','2','3','4','5','6','7','8','9','i','+','-','*','/','^','(',')'];
const digits = ['0','1','2','3','4','5','6','7','8','9'];

const exp = ref( new Array<AtomI>() );
const result = ref(new QGauss(Gauss.zero,1));
const index = ref(0);
const message = ref('');
const showResult = ref(false);

const shift = function(diff:number){
  showResult.value = false;
  message.value = '';
  const i = index.value + diff;
  if(i < 0){
    if(exp.value.length == 0){
      index.value = 0;
    }else{
      index.value = -1;
    }
  }else if(i >= exp.value.length){
    index.value = exp.value.length;
  }else{
    index.value = i;
  }
}
const clear = function(){
  exp.value.splice(0);
  index.value = 0;
  showResult.value = false;
  message.value = '';
}

const inputChar = function(val:string){
  showResult.value = false;
  message.value = '';
  if(allChars.includes(val)){
    const i = index.value;
    const shiftFlag = (i >= exp.value.length-1) ;
    if(i < 0 || i >= exp.value.length){
      addAtom(val);
    }else{
      const atom = exp.value[i];
      if( (atom.typ == 'r' || atom.typ == '^') && digits.includes(val) ){
	atom.num = Number(atom.num.toString() + val);
      }else if(atom.typ == 'r' && val == 'i'){
	atom.typ = 'i';
      }else if(atom.typ == '-' && digits.includes(val) && (i == 0 || exp.value[i-1].typ == '(') ){
	atom.typ = 'r';
	atom.num = -1*Number(val);
      }else if(atom.typ == '-' && val == 'i' && (i == 0 || exp.value[i-1].typ == '(') ){
	atom.typ = 'i';
	atom.num = -1;
      }else{
	addAtom(val);      
      }    
    }
    check();
    if(shiftFlag){
      if(digits.includes(val) || val == '^' || val == '-' && (exp.value.length <= 1 || exp.value[exp.value.length-2].typ == '(') ){
	index.value = exp.value.length-1;
      }else{
	index.value = exp.value.length;
      }
    }
//  }else{
//    console.log('add: bad character ' + val);
  }
}

const addAtom = function(val:string){
  const entry = {
    num: digits.includes(val) ? Number(val) : val == 'i' ? 1 : 0,
    typ: digits.includes(val) ? 'r' : val,
    error: false
  }
  index.value += 1;
  exp.value.splice(index.value,0,entry);
}
const del = function(){
  showResult.value = false;
  message.value = '';
  exp.value.splice(index.value,1);
  shift(-1);
  check();
}
const check = function(){
  let depth = 0;
  for(const atom of exp.value){
    atom.error = (atom.typ == '^' && atom.num <= 0);
    if(atom.typ == '('){
      depth += 1;
    }else if(atom.typ == ')'){
      depth -= 1;
      if(depth < 0){
	depth = Infinity;
      }
    }
  }
  if(depth != 0){
    for(const atom of exp.value){
      if(atom.typ == '(' || atom.typ == ')'){
	atom.error = true;
      }
    }
  }
  if(exp.value.length > 0 && ! ['r','i','('].includes(exp.value[0].typ) ){
    exp.value[0].error = true;
  }  
  for(let i=1; i< exp.value.length; i++){
    const atom = exp.value[i];
    const prev = exp.value[i-1];
    if( (prev.typ == 'r' || prev.typ == 'i' || prev.typ == '^') && ['r','i','('].includes(atom.typ)
      || ['+','-','*','/'].includes(prev.typ) && (['+','-','*','/','^',')'].includes(atom.typ) || atom.num < 0)
      || prev.typ == '(' && ['+','-','*','/','^',')'].includes(atom.typ)
      || prev.typ == ')' && ['r','i','('].includes(atom.typ)
      ){
      prev.error = true;
      atom.error = true;
    }
  }
}

let location = 0;

function factor(): QGauss{
  if(location < exp.value.length){
    const atom = exp.value[location];
    if(atom.typ == 'r'){
      location += 1;
      return new QGauss(new Gauss(atom.num,0), 1);
    }else if(atom.typ == 'i'){
      location += 1;
      return new QGauss(new Gauss(0,atom.num), 1);
    }else if(atom.typ == '('){
      location += 1;
      const v = expression();
      if(location < exp.value.length && exp.value[location].typ == ')'){
	location += 1;
	return v;
      }
    }
  }
  return QGauss.NaN;
}
function pFactor(): QGauss{
  const v = factor();
  if(location < exp.value.length){
    const atom = exp.value[location];
    if(atom.typ == '^'){
      location += 1;
      return v.pow(atom.num);
    }
  }
  return v;
}
function term(): QGauss{
  let v = pFactor();
  while(location < exp.value.length && exp.value[location].typ == '*'){
    location += 1;
    v = v.mul(pFactor());
  }
  return v;
}
function qTerm(): QGauss{
  let v = term();
  while(location < exp.value.length && exp.value[location].typ == '/'){
    location += 1;
    v = v.div(term());
  }
  return v;
}
function expression(): QGauss{
  let v = qTerm();
  while(location < exp.value.length && (exp.value[location].typ == '+' || exp.value[location].typ == '-')){
    if(exp.value[location].typ == '+'){
      location += 1;
      v = v.add(qTerm());
    }else{
      location += 1;
      v = v.sub(qTerm());
    }
  }
  return v;  
}

const keyDown = function(key:string){
  if(allChars.includes(key)){
    inputChar(key);
  }else if(key == 'ArrowLeft'){
    shift(-1);
  }else if(key == 'ArrowRight'){
    shift(1);
  }else if(key == 'Backspace' || key == 'Delete'){
    del();
  }else if(key == 'Enter'){
    calc();
  }
}

const calc = function(){
  showResult.value = false;
  index.value = exp.value.length;
  if(exp.value.some( a => a.error )){
    message.value = '入力に誤りがあります。';
    return;
  }
  location = 0;
  const res = expression();
  if(res.error){
    message.value = '入力に誤りがあります。';
    return;
  }
  message.value = '';
  showResult.value = true;
  result.value = res;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          (index.value == -1 && ! showResult.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exp.value, (atom, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              _createTextVNode("   "),
              (atom.typ != '^')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["atom", {error:atom.error, selected:index.value == i}]),
                    onClick: ($event: any) => (index.value = i)
                  }, [
                    (atom.typ == 'r')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(atom.num), 1)
                        ], 64))
                      : (atom.typ == 'i')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(atom.num) + "i ", 1)
                          ], 64))
                        : (atom.typ == '*')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(" × ")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(atom.typ), 1)
                            ], 64))
                  ], 10, _hoisted_5))
                : (_openBlock(), _createElementBlock("sup", {
                    key: 1,
                    class: _normalizeClass({error:atom.error, selected:index.value == i}),
                    onClick: ($event: any) => (index.value = i)
                  }, _toDisplayString(atom.num), 11, _hoisted_6))
            ], 64))
          }), 128)),
          (index.value >= exp.value.length && ! showResult.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7))
            : _createCommentVNode("", true)
        ]),
        (showResult.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " =   " + _toDisplayString(result.value.txt), 1))
          : _createCommentVNode("", true)
      ]),
      (message.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(message.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", {
          id: "item0",
          class: "panelB",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (inputChar('0')))
        }, " 0 "),
        _createElementVNode("div", {
          id: "item1",
          class: "panelB",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (inputChar('1')))
        }, " 1 "),
        _createElementVNode("div", {
          id: "item2",
          class: "panelB",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (inputChar('2')))
        }, " 2 "),
        _createElementVNode("div", {
          id: "item3",
          class: "panelB",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (inputChar('3')))
        }, " 3 "),
        _createElementVNode("div", {
          id: "item4",
          class: "panelB",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (inputChar('4')))
        }, " 4 "),
        _createElementVNode("div", {
          id: "item5",
          class: "panelB",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (inputChar('5')))
        }, " 5 "),
        _createElementVNode("div", {
          id: "item6",
          class: "panelB",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (inputChar('6')))
        }, " 6 "),
        _createElementVNode("div", {
          id: "item7",
          class: "panelB",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (inputChar('7')))
        }, " 7 "),
        _createElementVNode("div", {
          id: "item8",
          class: "panelB",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (inputChar('8')))
        }, " 8 "),
        _createElementVNode("div", {
          id: "item9",
          class: "panelB",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (inputChar('9')))
        }, " 9 "),
        _createElementVNode("div", {
          id: "itemi",
          class: "panelB",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (inputChar('i')))
        }, " i "),
        _createElementVNode("div", {
          id: "itemadd",
          class: "panelB panelO",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (inputChar('+')))
        }, " + "),
        _createElementVNode("div", {
          id: "itemsub",
          class: "panelB panelO",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (inputChar('-')))
        }, " - "),
        _createElementVNode("div", {
          id: "itemmul",
          class: "panelB panelO",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (inputChar('*')))
        }, " × "),
        _createElementVNode("div", {
          id: "itemdiv",
          class: "panelB panelO",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (inputChar('/')))
        }, " / "),
        _createElementVNode("div", {
          id: "itempow",
          class: "panelB panelO",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (inputChar('^')))
        }, " ^ "),
        _createElementVNode("div", {
          id: "itemlp",
          class: "panelB panelO",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (inputChar('(')))
        }, " ( "),
        _createElementVNode("div", {
          id: "itemrp",
          class: "panelB panelO",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (inputChar(')')))
        }, " ) "),
        _createElementVNode("div", {
          id: "itemleft",
          class: "panelB panelC",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (shift(-1)))
        }, " ← "),
        _createElementVNode("div", {
          id: "itemright",
          class: "panelB panelC",
          onClick: _cache[19] || (_cache[19] = ($event: any) => (shift(1)))
        }, " → "),
        _createElementVNode("div", {
          id: "itemdel",
          class: "panelB panelC",
          onClick: del
        }, " del "),
        _createElementVNode("div", {
          id: "itemclear",
          class: "panelB panelC",
          onClick: clear
        }, " AC "),
        _createElementVNode("div", {
          id: "itemcalc",
          class: "panelB panelC",
          onClick: calc
        }, " = ")
      ])
    ])
  ]))
}
}

})